/*
Door Hinges

  --type <string:: enum> | ['Five-Knuckle', 'Top Pivot', 'Bottom Pivot', 'Intermediate Pivot', 'Top & Bottom Pivot']
*/
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'

export default [
  ...hardwareFormFields,
  {
    key: 'type',
    value: 'type',
    type: 'select',
    required: true,
    classes: ['xs12', 'sm8'],
    attributes: {
      label: 'Type',
      required: true,
      class: ['input--dense']
    },
    values: ['Five-Knuckle', 'Top Pivot', 'Bottom Pivot', 'Intermediate Pivot', 'Top & Bottom Pivot']
  }
]
